import React, { useEffect } from 'react';
import { MapDispatchToProps, connect, useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';

// components
import Tile from 'pages/MerchantPages/Analytics/components/Tile';
import { CustomMap } from 'components/StyledMap';

// actions
import {
  SubscriptionParams,
  fetchSubscriptions as fetchSubscriptionsAction,
  SubscriptionFilterTypes,
  fetchSubscriptionsCountriesMap,
} from 'ducks/merchantDucks/subscriptions/actions';

// functions
import { convertReceivedDataToGeoJSON } from 'utils/convertReceivedDataToGeoJSON';
import Choropleth from 'components/Leaflet/Choropleth';
import customLegend from 'components/Legend/CustomLegend';
import RootState from 'ducks/RootState';

interface DispatchProps {
  fetchSubscriptions: (type: SubscriptionFilterTypes, params?: SubscriptionParams) => any;
}

type Props = DispatchProps;

export const LegendContainer = styled.div`
  .recharts-legend-wrapper {
    position: relative !important;
    margin-top: 5px;
  }
`;

const SubscriptionsPerCountry = ({ fetchSubscriptions }: Props) => {
  const dispatch = useDispatch();
  const { startDate, endDate } = useSelector((state: RootState) => state.datepicker);
  const chartData = useSelector((state: RootState) => state.subscriptions.countriesMapData.collection);
  useEffect(() => {
    dispatch(fetchSubscriptionsCountriesMap(startDate, endDate));
  }, [fetchSubscriptions, startDate, endDate]);

  const geojson = convertReceivedDataToGeoJSON(chartData);

  // temporarily disabled subs map due to lack of complete data from BE
  const SubscriptionsPerCountryMap = () => (
    <CustomMap center={[50, 0]} zoom={3} minZoom={2} maxBoundsViscosity={1} attributionControl={false}>
      <Choropleth geoJson={geojson} featureProp="density" mapDescriptionType="Subscription" />
    </CustomMap>
  );

  return (
    <Tile
      title="Subscriptions per country"
      legend={customLegend('country_code', '', 'total_active', chartData)}
      tileWidth="100%"
      tileContent={<SubscriptionsPerCountryMap />}
    />
  );
};

export const mapDispatchToProps: MapDispatchToProps<DispatchProps, {}> = {
  fetchSubscriptions: fetchSubscriptionsAction,
};

export default connect(null, mapDispatchToProps)(SubscriptionsPerCountry);
